import { THEME_RECORD_ID, DEFAULT_THEME, deriveThemeValues, applyTheme } from '~/composables/theme'

export default defineNuxtPlugin({
  name: 'theme',
  setup: async () => {
    try {
      const pb = usePocketBase()
      const data = await pb.collection('theme').getOne(THEME_RECORD_ID)
      if (data) {
        const vars = deriveThemeValues(data)
        applyTheme(vars)
      }
    } catch (e) {
      console.warn('Failed to load theme from PocketBase, using defaults', e)
      const vars = deriveThemeValues(DEFAULT_THEME)
      applyTheme(vars)
    }
  },
})
